import { Typography, makeStyles } from "@material-ui/core";

export type Field = { label: string; value: React.ReactNode };

type Props = {
  fields: Field[];
};

// Label / value grid used by every section of the file detail
export default function DetailFields({ fields }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.fields}>
      {fields.map(field => (
        <div key={field.label} className={classes.field}>
          <Typography variant="caption" color="textSecondary">
            {field.label}
          </Typography>
          <Typography variant="body2" component="div" className={classes.value}>
            {field.value}
          </Typography>
        </div>
      ))}
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  fields: { border: `1px solid ${theme.palette.divider}`, borderRadius: 4 },
  field: {
    display: "grid",
    gridTemplateColumns: "140px 1fr",
    gap: 12,
    padding: "10px 14px",
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.divider}`,
    "&:last-child": { borderBottom: 0 },
  },
  value: { wordBreak: "break-word", minWidth: 0 },
}));
